var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoperta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1014,
    height: 687,
    viewBox: "0 0 1014 687",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M993.5 652.5C993.5 660.5 986.9 667.1 978.9 667.1H35.1C27.1 667.1 20.5 660.5 20.5 652.5V37.4999C20.5 29.4999 27.1 22.8999 35.1 22.8999H978.7C986.7 22.8999 993.3 29.4999 993.3 37.4999V652.5H993.5Z",
    stroke: "#fff",
    strokeWidth: 39.0795,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.8999 22.8999C27.9999 22.8999 26.7999 26.9999 34.1999 31.9999L493.5 336C501 341 513.2 341 520.7 336L979.9 31.9999C987.4 26.9999 986.1 22.8999 977.2 22.8999H36.8999Z",
    stroke: "#fff",
    strokeWidth: 43.9643,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoperta);
export default __webpack_public_path__ + "static/media/koperta.89e9d14d8c2a9311167be5ae164d8685.svg";
export { ForwardRef as ReactComponent };